// @flow
import type { AnyAction } from 'react-redux';
import { combineReducers } from 'redux';
import type { Reducer } from 'redux';

import type { State } from '../../../types';

import details from './details';
import list from './list';

export default (combineReducers({
  list,
  details,
}): Reducer<State['results'], AnyAction>);
